export default __webpack_public_path__ + "content/media/33.9b978f78.jpg";